<template>
  <div class="page">
    <form @keyup.enter="saveCorporateDetails">
      <!-- <form> -->
      <ion-grid fixed>
        <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
          <ion-col>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Corporate Name
                  <span class="required">*</span>
                </ion-label>
                <div   :class= "mode == 'UPDATE' ? 'border-line-34 margin-top-10 readonly' : 'border-line-34 margin-top-10'" v-if ="mode == 'UPDATE'">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Corporate Name"
                    :value="corporateAliasName"
                    @ionChange="corporateAliasName = $event.target.value"
                    maxlength="100"
                    :readonly = 'mode == "UPDATE" ? true : false'
                  ></ion-input>
                </div>
                <div  :class= "mode == 'UPDATE' ? 'border-line-34 margin-top-10 readonly' : 'border-line-34 margin-top-10'" v-if ="mode != 'UPDATE'">
                  <ion-select
                    class="form-select select-mobile"
                    :value="corporateName"
                    @ionChange="corporateName = $event.target.value"
                    placeholder="Select corporate name"
                    interface="action-sheet"
                    :readonly = 'mode == "UPDATE" ? true : false'
                  >
                    <ion-select-option
                      v-for="(corporateName, index) in this.corporateNameList"
                      :key="index"
                      :value="corporateName.corporateId"
                    >{{corporateName.corporateName}}</ion-select-option>
                  </ion-select>
                  <select
                    class="input-select select-web"
                    v-model="corporateName"
                    :disabled = 'mode == "UPDATE" ? true : false'
                    placeholder="Select corporate name"
                  >
                    <option
                      v-for="(val, index) in corporateNameList"
                      :key="index"
                      :value="val.corporateId"
                    >{{val.corporateName}}</option>
                  </select>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                    Branch Name
                    <span class="required">*</span>
                  </ion-label>
                <div class='border-line-34 margin-top-10'>
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Branch Name"
                    @input="branch = $event.target.value"
                    :value="branch"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                    Mobile#1
                    <span class="required">*</span>
                  </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder="Enter Mobile Number"
                    @input="mobile1 = $event.target.value"
                    :value="mobile1"
                    maxlength="10"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Mobile#2
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder="Enter  Mobile Number"
                    @input="mobile2 = $event.target.value"
                    :value="mobile2"
                    maxlength="10"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Primary Contact Person
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Primary Contact Person"
                    @input="primaryContactPerson = $event.target.value"
                    :value="primaryContactPerson"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Secondary Contact Person
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Secondary Contact Person"
                    @input="secondaryContactPerson = $event.target.value"
                    :value="secondaryContactPerson"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  GST Number
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter GST Number"
                    @input="gstNumber = $event.target.value"
                    :value="gstNumber"
                    maxlength="15"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Email#1
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder="Enter Email"
                    @input="email = $event.target.value"
                    :value="email"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Email#2
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder="Enter Email"
                    @input="email2 = $event.target.value"
                    :value="email2"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Email#3
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder="Enter Email"
                    @input="email3 = $event.target.value"
                    :value="email3"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Status
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-select
                    class="form-select select-mobile"
                    :value="status"
                    @ionChange="changeStatus($event)"
                    placeholder="Select Status"
                    interface="action-sheet"
                  >
                    <ion-select-option
                      v-for="(status, index) in this.statuses"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</ion-select-option>
                  </ion-select>
                  <!-- </div> -->
                  <!-- <div class="border-line select-web"> -->
                  <select class="input-select select-web" v-model="status" @change="changeStatus($event)" placeholder="Select Status">
                    <option
                      v-for="(val, index) in this.statuses"
                      :key="index"
                      :value="val.id"
                    >{{val.name}}</option>
                  </select>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding" v-if="retireReasonInd">
                <ion-label class="section-item" position="stacked">
                  Retire Reason
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="retireReason"
                    placeholder="Enter Retire Reason"
                    @input="retireReason = $event.target.value"
                    :value="retireReason"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="secondary-text">Address</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Building Name
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Building Name"
                    @input="line1 = $event.target.value"
                    :value="line1"
                    maxlength="500"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Street Address
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Street Address"
                    @input="line2 = $event.target.value"
                    :value="line2"
                    maxlength="500"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Area Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Area Name"
                    @input="line3 = $event.target.value"
                    :value="line3"
                    maxlength="500"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  City
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter City"
                    @input="city = $event.target.value"
                    :value="city"
                    maxlength="500"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  State
                  <span class="required">*</span>
                </ion-label>
                <div  class="border-line-34 margin-top-10">
                  <ion-select
                    :value="state"
                    class="form-select popover-content select-mobile"
                    @ionChange="state = $event.target.value"
                    placeholder="Select State"
                    interface="action-sheet"
                  >
                    <ion-select-option  v-for="(state, index) in this.states"
                      :key="index"
                      :value="state.code"
                    >{{state.name}}
                      
                    </ion-select-option>
                  </ion-select>
                <!-- </div>
                <div class="border-line select-web"> -->
                  <select class="input-select select-s select-web" v-model="state" placeholder="Select State" >
                    <option
                      v-for="(state, index) in this.states"
                      :key="index"
                      :value="state.code"
                    >{{ state.name }}</option>
                  </select>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Pincode
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder="Enter Pincode"
                    @input="zipcode = $event.target.value"
                    :value="zipcode"
                    maxlength="6"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row align-items-stretch>
          <ion-col size="12" class="col-nopadding ion-text-right">
            <ion-button class="btn-primary" @click="cancel">Cancel</ion-button>
            <ion-button class="btn-primary" @click="saveCorporateDetails" :disabled = "diableSaveBtn">Save</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { ProfilerService } from "../../service/profile/profiler.service";
import { LocationService } from "../../service/location/location.service";

import { LocalStorage } from "../../data/localstorage";
import { migratedTryParseServiceError } from "../../service";
import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError } from "../../service";

import { CorporateService } from "../../service/corporate/corporate.service";
import { CorporateDetails } from "../../entity/corporate/corporateDetails";
import { CorporateAddress } from '@/entity/corporate/corprateAddress';
import { CorporateState } from '@/entity/corporate/corporateState';
import { flash } from 'ionicons/icons';
import { IonButton, IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner, IonCheckbox  } from "@ionic/vue";

export default defineComponent ({
  name: 'branchDetails',
  components:{
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner, IonCheckbox 
  },
  data() {
    return {
      reportList: [],
      loaderTab: true,
      mode: "ADD",
      columnEditPermission: [],
      states: "",
      corporateNameList: [],
      id: "",
      corporateName: "",
      corporateAliasName: "",
      branch: "",
      mobile1: "",
      mobile2: "",
      email: "",
      email2: "",
      email3: "",
      faxNumber: "",
      landline: "",
      primaryContactPerson: "",
      secondaryContactPerson: "",
      gstNumber: "",
      panNo: "",
      status: "",
      line1: "",
      line2: "",
      line3: "",
      city: "",
      state: "",
      zipcode: "",
      statuses: [],
      retireReason: "",
      retireReasonInd: false,
      branchHdrId: "",
      diableSaveBtn: false,
      reportOptions : [
        { description: 'Usage Report', code: 'usageReport' },
        { description: 'Transaction Report', code: 'transactionReport' },
        { description: 'Charger Status Report', code: 'chargerReport' }
      ]
    }
  },
  async mounted() {
   
    try {
      this.reportList = await new CorporateService().getReportList();
      let userBranchDetails = JSON.parse(localStorage.getItem('branchInfo'));
      let states = await new LocationService().states();
      this.states = states;
      this.statuses = await new CorporateService().getBranchStatus();
      let profile = await new CorporateService().getCorporates(new LocalStorage().user);
      this.corporateNameList = profile;
      if(this.mode == "ADD") {
        this.columnEditPermission = await new CorporateService().corporateEditPermission();
        this.loaderTab = false;
      }
      if (userBranchDetails != null && userBranchDetails.branchId) {
      
        let corporateDetails = await new CorporateService().getBranchDetailsById(
            // this.$route.params.corporateId
            userBranchDetails.branchId
        );
        this.fillCorporateDetails(corporateDetails);
      }
      // this.loaderTab = false;
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
  },
  beforeUnmounted() {
    // console.log('unmounted')
  },

  methods: {

    changeStatus(event) {
      this.status = event.target.value;
      if(this.status == "RET") {
        this.retireReasonInd = true;
      } else {
        this.retireReasonInd = false;
      }
    },
   
    fillCorporateDetails(corporate) {
    
      this.mode = "UPDATE";
      this.branchHdrId = corporate.branchId;
      this.corporateName = corporate.corporateId;
      this.corporateAliasName = corporate.corporateName;
      this.branch = corporate.branch;
      this.mobile1 = corporate.mobile1;
      this.primaryContactPerson = corporate.primaryContactPerson;
      this.gstNumber = corporate.gstNumber;
      this.email = corporate.email;
      this.email2 = corporate.email2;
      this.email3 = corporate.email3;
      this.status = corporate.status.code;
      this.mobile2 = corporate.mobile2;
      this.landline = corporate.landline;
      this.secondaryContactPerson = corporate.secondaryContactPerson
      this.line1 = corporate.addressLine1;
      this.line2 = corporate.addressLine2;
      this.line3 = corporate.addressLine3;
      this.city = corporate.city;
      this.state = corporate.state.code;
      this.zipcode = corporate.pincode;
      this.retireReason = corporate.retireReason;
      // if(corporate.reportAccess.length > 0) {
      //   let reportPermission= [];
      //   for(let i = 0; i < this.reportList.length; i++){ 
      //     for(let j = 0; j < corporate.reportAccess.length; j++) {
      //       if(this.reportList[i].code == corporate.reportAccess[j].code) {
      //         reportPermission.push(this.reportList[i])
      //       }
      //     }
      //   }
        
      // }
      this.loaderTab = false;
    },
    getPermission(columnName) {
      
      if(this.columnEditPermission.data) {
        for(let i = 0; i < this.columnEditPermission.data.length; i++) {
          if(columnName == this.columnEditPermission.data[i].columnName && this.columnEditPermission.data[i].editPermission == "T") {
            return true;
          }
        }
      }
      
      this.loaderTab = false;
    },
    async saveCorporateDetails() {
      try {
          if (
            typeof this.corporateName === "undefined" ||
            this.corporateName === null ||
            this.corporateName === "" ||
            (this.corporateName).toString().trim().length === 0
          ) {
            new ToastUtils().presentToast("Select Corporate Name");
          } 
          else if (
            typeof this.branch === "undefined" ||
            this.branch === null ||
            this.branch === "" ||
            this.branch.trim().length === 0
          ) {
              new ToastUtils().presentToast("Enter Branch Name");
          } else if (
            typeof this.mobile1 === "undefined" ||
            this.mobile1 === null ||
            this.mobile1 === "" ||
            this.mobile1.trim().length === 0
          ) {
              new ToastUtils().presentToast("Enter Mobile#1 Number");
          } else if(new ValidationUtils().mobile(this.mobile1) === false) {
              new ToastUtils().presentToast("Enter Valid Mobile#1 Number");
          } 
          else if(this.mobile2.length != 0 && new ValidationUtils().mobile(this.mobile2) === false) {
              new ToastUtils().presentToast("Enter Valid Mobile#2 Number");
          } else if(
            typeof this.primaryContactPerson === "undefined" ||
            this.primaryContactPerson === null ||
            this.primaryContactPerson === "" ||
            this.primaryContactPerson.trim().length === 0
            ) {
            new ToastUtils().presentToast("Enter Primary Contact Person"); 
          } else if(this.gstNumber == "undefined" || 
            this.gstNumber === null || this.gstNumber === "" || 
            this.gstNumber.trim().length === 0
            ) {
              new ToastUtils().presentToast("Enter GST Number"); 
          } else if(new ValidationUtils().validateGSTNumber(this.gstNumber) === false) {
            new ToastUtils().presentToast("Enter Valid GST Number"); 
          }
          else if(this.email == "undefined" || 
            this.email === null || this.email === "" || 
            this.email.trim().length === 0
            ) {
              new ToastUtils().presentToast("Enter Email ID"); 
          } else if(new ValidationUtils().email(this.email) === false) {
              new ToastUtils().presentToast("Enter Valid Email ID");
          } else if (this.email2 != "" && new ValidationUtils().email(this.email2) === false) {
              new ToastUtils().presentToast("Enter Valid Email2 ID");
          } else if(this.email3 != "" && new ValidationUtils().email(this.email3) === false) {
              new ToastUtils().presentToast("Enter Valid Email3 ID");
          } 
          
          else if(this.status == "undefined" || this.status === null || this.status === "" || this.status.trim().length === 0) {
              new ToastUtils().presentToast("Select Status");
          } 
          else if(this.status == "RET" && (this.retireReason == "" || this.retireReason == "undefined" || this.retireReason == null || this.retireReason.trim().length === 0)) {
            new ToastUtils().presentToast("Enter Retire Reason");
          }
           else if (
            typeof this.line2 === "undefined" ||
            this.line2 === null ||
            this.line2 === "" ||
            this.line2.trim().length === 0
          ) {
            new ToastUtils().presentToast("Enter Street Address");
          } else if (
            typeof this.line3 === "undefined" ||
            this.line3 === null ||
            this.line3 === "" ||
            this.line3.trim().length === 0
          ) {
            new ToastUtils().presentToast("Enter Area Name");
          } else if (
            typeof this.city === "undefined" ||
            this.city === null ||
            this.city === "" ||
            this.city.trim().length === 0
          ) {
            new ToastUtils().presentToast("Enter City");
          } 
          else if (
            typeof this.state === "undefined" ||
            this.state === null ||
            this.state === ""
          ) {
            new ToastUtils().presentToast("Select State");
          } else if (
            typeof this.zipcode === "undefined" ||
            this.zipcode === null ||
            this.zipcode === "" ||
            this.zipcode.trim().length === 0
          ) {
            new ToastUtils().presentToast("Enter Pincode");
          } else if(new ValidationUtils().validatePincode(this.zipcode) === false) {
            new ToastUtils().presentToast("Enter Valid Pincode");
          } 
          else {
            this.loaderTab = true;           
            if(this.mode == "ADD") {
              this.diableSaveBtn = true;
              await new CorporateService().createBranchDetailsByAuthor(
                new CorporateDetails(
                  this.corporateName,
                  this.branch,
                  this.mobile1,
                  this.primaryContactPerson,
                  this.gstNumber,
                  this.email,
                  this.status,
                  this.email2,
                  this.email3,
                  this.mobile2,
                  this.landline,
                  this.secondaryContactPerson,
                  new CorporateAddress(
                    this.line1.trim(),
                    this.line2.trim(),
                    this.line3.trim(),
                    "",
                    this.city.trim(),
                    new CorporateState(this.state),
                    this.zipcode
                  )
                ), 
                new LocalStorage().user
              ).then((data) => {
                this.diableSaveBtn = false;
                this.loaderTab = false;
                new ToastUtils().presentToast("Branch details saved successfully");
                this.$router.back();
              }).catch((error) => {
                this.loaderTab = false;
                this.diableSaveBtn = false;
                let serviceError = migratedTryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError.description);
                new ToastUtils().presentToast(serviceError.description);
              });
              
            } else {
              this.loaderTab = true;
              this.diableSaveBtn = true;
              await new CorporateService().updateBranchDetailsByAuthor(
                new CorporateDetails(                  
                  this.corporateName,
                  this.branch,
                  this.mobile1,
                  this.primaryContactPerson,
                  this.gstNumber,
                  this.email,
                  this.status,
                  this.email2,
                  this.email3,
                  this.mobile2,
                  this.landline,
                  this.secondaryContactPerson,
                  new CorporateAddress(
                    this.line1.trim(),
                    this.line2.trim(),
                    this.line3.trim(),
                    "",
                    this.city.trim(),
                    new CorporateState(this.state),
                    this.zipcode
                  ),
                  this.status == "A" ? "" : this.retireReason,
                  this.branchHdrId,
                ), 
                new LocalStorage().user
              ).then((data) => {
                this.loaderTab = false;
                this.diableSaveBtn = false;
                new ToastUtils().presentToast("Branch details updated successfully");
                this.$router.back();
              }).catch((error) => {
                // alert(error)
                this.loaderTab = false;
                this.diableSaveBtn = false;
                let serviceError = migratedTryParseServiceError(error);
                new AlertUtils().presentAlert(serviceError.description);
              });
            }
          }
      } catch(err) {
        this.loaderTab = false;
          alert(err)
      }
    },
    cancel() {
      this.$router.back();
    }
  }
})
</script>

<style scoped>
.carImage {
  width: 10rem;
}
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.select-spacing::part(icon) {
  margin-left: 60px;
}
</style>